/* eslint-disable */
import React, { Component } from 'react'
import gql from 'graphql-tag'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from 'react-select'
// import InputLabel from '@material-ui/core/InputLabel'
import ClientDetails from './ClientDetails'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import PropTypes from 'prop-types'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import { withApollo } from 'react-apollo'
import { DatePicker } from 'material-ui-pickers'

import moment from 'moment'
import './vehicle.css'
import { Switch } from '@material-ui/core'

const GET_DEVICE_DETAILS = gql`
  query getAllAssignedDevicesToClient($clientId: Int!) {
    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {
      uniqueDeviceId
      deviceModel {
        model_name
      }
    }
  }
`
const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int, $status: Int) {
    clientsDetails: allClientDetails(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      clientName

      loginId
      partner {
        businessName
      }
    }
  }
`

const GET_BRANDS = gql`
  query GetBrands($clientLoginId: Int!) {
    getBrands(clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        client_login_id
        created_at
        updated_at
      }
    }
  }
`
export const GET_MODELS_BY_BRAND = gql`
  query GetModelsByBrand($brandId: Int!, $clientLoginId: Int!) {
    getModelsByBrand(brandId: $brandId, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        cum_weight
        client_login_id
        truck_brand_id
        created_at
        updated_at
      }
    }
  }
`

const GET_VLPN = gql`
  query checkVehicleNumber($vlpn: String!) {
    checkVehicleNumber(vehicleNumber: $vlpn)
  }
`
const GET_SELECT_DEV_DETAILS = gql`
  query devicePartnerAssignDetail($uniqueId: String) {
    devicePartnerAssignDetail(uniqueDeviceId: $uniqueId) {
      deviceModel {
        id
        model_name
        devicetype
      }
      uniqueDeviceId
    }
  }
`
const GET_SIM_DETAILS = gql`
  query getAllAssignedSimToClient($clientId: Int!) {
    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {
      id
      simId
      sim {
        phoneNumber
      }
    }
  }
`
const GET_ACCESSORY_DETAILS = gql`
  query getAllAssignedAccessoryToClient($clientId: Int!) {
    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {
      accessory {
        uniqueAccessoryId
      }
    }
  }
`

const GET_SELECT_PHONE_DETAILS = gql`
  query simPartnerAssignDetail($simId: Int) {
    simPartnerAssignDetail(simId: $simId) {
      sim {
        simNumber
      }
      serviceProvider {
        name
      }
    }
  }
`
// calling server for updation
const ADD_VEHICLE = gql`
  mutation addVehicleDetail(
    $vehicleNumber: String!
    $engineNumber: String
    $chassisNumber: String
    $clientLoginId: Int!
    $uniqueDeviceId: String!
    $simId: Int!
    $speedSensorType: String!
    $speedLimit: Int!
    $uniqueAccessoryId: String
    $vehicleType: String!
    $vehicleMake: String
    $averageMileage: Int
    $vehicleModel: String!
    $vehicleCapacity: Int
    $isActivated: Boolean
    $partnerSubscriptionId: Int!
    $accountType: String
    $vehicleIdentificationNumber: String
    $vehicleColor: String
    $invoiceNumber: String
    $equipmentSerialNumber: String
    $commissioningDate: Int
    $department: String
    $idlingSpeed: Int
    $equipmentName: String
    $contractorName: String
    $phoneIMEI: String
    $vinNumber:String
    $truckBrandId: Int
    $truckModelId: Int
  ) {
    addVehicleDetail(
      vehicleNumber: $vehicleNumber
      engineNumber: $engineNumber
      chassisNumber: $chassisNumber
      clientLoginId: $clientLoginId
      uniqueDeviceId: $uniqueDeviceId
      simId: $simId
      speedSensorType: $speedSensorType
      speedLimit: $speedLimit
      uniqueAccessoryId: $uniqueAccessoryId
      partnerSubscriptionId: $partnerSubscriptionId
      vehicleType: $vehicleType
      vehicleMake: $vehicleMake
      averageMileage: $averageMileage
      vehicleModel: $vehicleModel
      vehicleCapacity: $vehicleCapacity
      isActivated: $isActivated
      accountType: $accountType
      vehicleIdentificationNumber: $vehicleIdentificationNumber
      vehicleColour: $vehicleColor
      invoiceNumber: $invoiceNumber
      equipmentSerialNumber: $equipmentSerialNumber
      commissioningDate: $commissioningDate
      department: $department
      idlingSpeed: $idlingSpeed
      equipmentName: $equipmentName
      contractorName: $contractorName
      phoneIMEI: $phoneIMEI
       vinNumber:$vinNumber
      truckBrandId: $truckBrandId
      truckModelId: $truckModelId
    )
  }
`
const GET_CLIENT_DETAILS_BYID = gql`
  query clientDetail($clientId: Int!) {
    clientDetail(loginId: $clientId) {
      clientName
      address
      city
    }
  }
`
// Engine Number validation
const CHECK_ENGINE_NUMBER = gql`
  query checkEngineNumber($engineNumber: String!) {
    checkEngineNumber(engineNumber: $engineNumber)
  }
`
// CHASSIS Number validation
const CHECK_CHASSIS_NUMBER = gql`
  query checkChassisNumber($chassisNumber: String!) {
    checkChassisNumber(chassisNumber: $chassisNumber)
  }
`
const GET_SUBSCRIPTION_BY_PARTNERID = gql`
  query getAllPartnerSubscriptions(
    $partnerId: Int
    $deviceModelId: Int
    $status: [Int]
  ) {
    getAllPartnerSubscriptions(
      partnerLoginId: $partnerId
      deviceModelId: $deviceModelId
      status: $status
    ) {
      id
      deviceTrackingCharges
      totalSoftwareQty
    }
  }
`
class VehicleRegistration extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSpeedLimitValid: true,
      isSeatLimitValid: true,
      speedLimit: '',
      seatLimit: null,
      serialNumber: '',
      partnerLoginId: getLoginId(),
      // partnerLoginId: 8,
      isSerialNumberValid: true,
      modelName: '',
      deviceType: '',
      status: 1,
      phoneNumber: '',
      isPhoneNoValid: true,
      simProvider: '',
      simNumber: '',
      vlpn: '',
      isVlpnValid: true,
      vehicleModel: '',
      vinNumber:'',
      isVehicleModelValid: true,
      isVinNumber:true,
      clientName: '',
      brandsDetails: '',
      isClientNameValid: true,
      vehicleType: '',
      truckBrand: '',
      vehicleModel: '',

      truckModel: '',
      modelsDetails: '',
      isVehicleTypeValid: true,
      speedSensor: '',
      isSpeedSensorValid: true,
      accessories: null,
      clientsDetails: [],
      deviceDetails: [],
      simDetails: [],
      accessoryDetails: [],
      response: false,
      failure: false,
      schoolBusEnable: false,
      installStatus: true,
      isengineNumberValid: true,
      engineNumber: null,
      chassisNumber: null,
      ischassisNumberValid: true,
      vlpnres: '',
      client: '',
      chassisres: '',
      engineres: '',
      subscriptionId: '',
      mmtc: '',
      noOfDevices: '',
      subscriptionDetails: [],
      idlingSpeed: 3,
      invoiceNumber: '',
      equipmentSerialNumber: null,
      equipmentName: '',
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      deviceModelId: '',
      department: '',
      contractorName: '',
      phoneIMEI: '',
      addPhoneDetails: false
    }

    if (this.props.location.state) {
      this.setState({ clientName: this.props.location.state.clientId })
    } else {
      this.setState({ clientName: '' })
    }
  }

  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }

  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate })
  }

  fetchAllPartnerSubscriptions = async () => {
    const {
      data: subscription,
      error: subscriptionError
    } = await this.props.client.query({
      query: GET_SUBSCRIPTION_BY_PARTNERID,
      variables: {
        partnerId: getLoginId(),
        deviceModelId: this.state.deviceModelId,
        status: [2, 4, 5]
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    })
    console.log('subscr', subscription)

    const allSubscriptions = subscription.getAllPartnerSubscriptions.map(
      // (lab = subscription.mmtc + ',' + subscription.noOfDevices),
      subscription => ({
        value: subscription.id,
        label: `${subscription.totalSoftwareQty} - ${
          subscription.deviceTrackingCharges
        }`
      })
    )
    if (subscriptionError) {
      this.setState({ subscriptionDetails: [] })
    } else {
      this.setState(
        {
          subscriptionDetails: allSubscriptions
        },
        () => console.log('subscriptionDetails', this.state.subscriptionDetails)
      )
    }
  }

  handleChangeDevice = client => async event => {
    console.log('event', client, event)
    if (event) {
      this.setState({ serialNumber: event.value })
      const response = await client
        .query({
          query: GET_SELECT_DEV_DETAILS,
          variables: { uniqueId: event.value },
          fetchPolicy: 'network-only'
        })
        .catch(error => {
          console.log(error.graphQLErrors[0].message)
        })

      console.log('devdata', response)
      if (response && response.data) {
        const { data } = response
        this.setState(
          {
            modelName: data.devicePartnerAssignDetail.deviceModel.model_name,
            deviceType: data.devicePartnerAssignDetail.deviceModel.devicetype,
            uniqueId: this.state.serialNumber,
            deviceModelId: data.devicePartnerAssignDetail.deviceModel.id
          },
          () => {
            this.fetchAllPartnerSubscriptions()
          }
        )
      }
    } else {
      this.setState({
        modelName: '',
        deviceType: '',
        uniqueId: '',
        serialNumber: '',
        subscriptionDetails: [],
        subscriptionId: ''
      })
    }

    // await this.onCountryFetched(data.allStatesByCountryId)
  }

  handleChangePhoneNumber = client => async event => {
    // this.setState({ phoneNumber: event.target.value })
    if (event) {
      const { data } = await client.query({
        query: GET_SELECT_PHONE_DETAILS,
        variables: { simId: event.value }
      })

      this.setState({
        simProvider: data.simPartnerAssignDetail.serviceProvider.name,
        simNumber: data.simPartnerAssignDetail.sim.simNumber,
        phoneNumber: event.value
      })
    } else {
      this.setState({
        simProvider: '',
        simNumber: '',
        phoneNumber: ''
      })
    }
  }

  handleChangeClient = async event => {
    console.log('this.state.clientName', this.state.clientName)
    let cltId = ''
    // console.log('chl', this.props.match.params.loginId)
    if (this.props.match.params.loginId === undefined) {
      // console.log(event, 'event')
      if (event) {
        cltId = parseInt(event.value, 10)
      }
    } else {
      cltId = parseInt(this.props.match.params.loginId, 10)
      this.props.match.params.loginId = undefined
    }
    // console.log(cltId, 'cltId')
    this.setState({ clientName: cltId })

    if (cltId !== '') {
      const { data } = await this.props.client.query({
        query: GET_CLIENT_DETAILS_BYID,
        variables: { clientId: cltId },
        errorPolicy: 'all'
        // fetchPolicy: 'network-only'
      })
      // console.log(data, 'data')

      const {
        data: device,
        error: deviceError
      } = await this.props.client.query({
        query: GET_DEVICE_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })

      const allDevices = device.device.map(device => ({
        value: device.uniqueDeviceId,
        label: device.uniqueDeviceId
      }))
      console.log('all devices', allDevices)
      const {
        data: simDetails,
        error: simError
      } = await this.props.client.query({
        query: GET_SIM_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })
      const allSims = simDetails.simDetails.map(sim => ({
        value: sim.simId,
        label: sim.sim.phoneNumber
      }))

      const { data: accessory, error } = await this.props.client.query({
        query: GET_ACCESSORY_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })
      // console.log(
      //   accessory.getAllAssignedAccessoryToClient[0].accessory
      //     .uniqueAccessoryId,
      //   'acceass'
      // )
      if (accessory.getAllAssignedAccessoryToClient) {
        const allAccessory = accessory.getAllAssignedAccessoryToClient.map(
          accessory1 => ({
            value: accessory1.accessory.uniqueAccessoryId,
            label: accessory1.accessory.uniqueAccessoryId
          })
        )
        console.log(allAccessory, 'acce')
        if (error) {
          this.setState({ accessoryDetails: [] })
        } else {
          this.setState({
            accessoryDetails: allAccessory
          })
        }
      }

      if (deviceError) {
        this.setState({ deviceDetails: [] })
      } else {
        this.setState({ deviceDetails: allDevices })
      }
      if (simError) {
        this.setState({ simDetails: [] })
      } else {
        this.setState({ simDetails: allSims })
      }

      // console.log(this.state.accessoryDetails, 'accessory')
      this.setState({
        client: data.clientDetail.clientName,
        address: data.clientDetail.address,
        city: data.clientDetail.city,
        totalRegisteredVehicle: 30,
        totalActiveDevicess: 15,
        totalInactiveDevices: 5,
        showClientDetails: true
      })
    } else {
      this.setState({
        client: '',
        address: '',
        city: '',
        showClientDetails: false,
        subscriptionDetails: [],
        accessoryDetails: [],
        simDetails: [],
        deviceDetails: [],
        modelName: '',
        deviceType: '',
        uniqueId: '',
        serialNumber: '',
        simProvider: '',
        simNumber: '',
        phoneNumber: '',
        accessories: '',
        subscriptionId: ''
      })
    }

    this.getAllBrands()
  }
  handleChangeType = event => {
    if (event) {
      this.setState({ vehicleType: event.value })
    } else {
      this.setState({ vehicleModel: '' })
    }
  }
  handleChangeBrand = event => {
    if (event) {
      console.log('Selected Brand:', event)
      this.setState({ truckBrand: event.value })
      this.getModelsByBrand(event.value) // Fetch models for the selected brand
    } else {
      console.log('Brand selection cleared')
      this.setState({
        truckBrand: null, // Clear the brand selection
        modelsDetails: '', // Clear the models if brand is cleared
        vehicleType: null // Clear the selected model
      })
    }
  }

  handleChangeModel = event => {
    if (event) {
      this.setState({ truckModel: event.value })
    } else {
      this.setState({ truckModel: '' })
    }
  }
  handleChangeSpeedSensor = event => {
    if (event) {
      this.setState({ speedSensor: event.value })
    } else {
      this.setState({ speedSensor: '' })
    }
  }
  handleChangeIdlingSpeed = event => {
    if (event) {
      this.setState({ idlingSpeed: event.value })
    } else {
      this.setState({ idlingSpeed: 3 })
    }
  }
  handleChangeAccessories = event => {
    if (!event) {
      this.setState({ accessories: '' })
    } else {
      this.setState({ accessories: event.value })
    }
  }
  handleChangeSubscription = event => {
    if (!event) {
      this.setState({ subscriptionId: '' })
    } else {
      this.setState({ subscriptionId: event.value })
    }
  }
  checkSerialNumberValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z\s]+$/)
    this.setState({
      isSerialNumberValid: this.state.serialNumber !== ''
    })
  }
  checkAddressValidity = () => {
    const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && this.state.address === ''
    })
  }
  checkVehicleModelValidity = () => {
       const regex = new RegExp(/^[a-zA-Z0-9]+(?:[\s-][a-zA-Z0-9]+)*$/)
    this.setState({
      isVehicleModelValid:
        regex.test(this.state.vehicleModel) &&
        this.state.vehicleModel !== '' &&
        this.state.vehicleModel.length > 1 &&
        this.state.vehicleModel.length < 21
    })
  }
  checkSpeedLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{0,2}$/)
    this.setState({
      isSpeedLimitValid:
        regex.test(this.state.speedLimit) &&
        this.state.speedLimit !== '' &&
        this.state.speedLimit <= 160
    })
  }
  checkSeatLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]$/)
    this.setState({
      isSeatLimitValid:
        regex.test(this.state.seatLimit) && this.state.seatLimit !== ''
    })
  }
  checkVlpnValidity = client => async event => {
    // const regex = new RegExp(/^[A-Z]{2}[0-9]{2}[A-Z]{2,3}[0-9]{4}$/)
    // this.setState({
    //   isVlpnValid: regex.test(this.state.vlpn) && this.state.vlpn !== ''
    // })
    const { data } = await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })
    this.setState({
      // isVlpnValid: data.checkVehicleNumber === 'AVAILABLE'
      isVlpnValid:
        this.state.vlpn !== '' &&
        data.checkVehicleNumber === 'AVAILABLE' &&
        this.state.vlpn.length > 4 &&
        this.state.vlpn.length < 33
    })
    if (data.checkVehicleNumber !== 'AVAILABLE') {
      this.setState({ vlpnres: 'Vehicle Number Already Exist!' })
    } else if (this.state.vlpn !== '') {
      this.setState({ vlpnres: 'Invalid Vehicle Number' })
    }
  }
  checkVlpnUnique = client => async event => {
    const { data } = await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })
    this.setState({
      isVlpnValid: data.checkVehicleNumber === 'AVAILABLE'
    })
    // await this.onCountryFetched(data.allStatesByCountryId)
  }
  checkClientNameValidity = () => {
    this.setState({
      isClientNameValid: this.state.clientName !== ''
    })
  }

  checkVehicleTypeValidity = () => {
    this.setState({
      isVehicleTypeValid: this.state.vehicleType !== ''
    })
    if (this.state.vehicleType === 'school bus') {
      this.setState({
        isseatLimitValid: true
      })
    } else {
      this.setState({
        isseatLimitValid: false
      })
    }
  }

  checkSpeedSensorValidity = () => {
    this.setState({
      isSpeedSensorValid: this.state.speedSensor !== ''
    })
  }

  getVehicleType = val => {
    const vehicleMap = {
      'School Bus': 'SchoolBus',
      '3-Wheeler': 'ThreeWheeler',
      'Premium Buggy': 'PremiumBuggy'
    }

    return vehicleMap[val] || val
  }

  handleSubmit = client => async event => {
    if (this.state.seatLimit === '') {
      this.setState({ seatLimit: null })
    }
    event.preventDefault()
    let commissioningDate =
      this.state.commissioningDate.date === null
        ? null
        : parseInt(this.state.commissioningDate.unix)

    const { data, errors } = await client.mutate({
      mutation: ADD_VEHICLE,
      variables: {
        vehicleNumber: this.state.vlpn,
        clientLoginId: parseInt(this.state.clientName, 10),
        uniqueDeviceId: this.state.serialNumber,
        simId: parseInt(this.state.phoneNumber, 10),
        speedSensorType: this.state.speedSensor,
        speedLimit: parseInt(this.state.speedLimit, 10),
        vehicleType: this.getVehicleType(this.state.vehicleType),
        vinNumber: this.state.vinNumber === "" ? null : this.state.vinNumber,
        vehicleModel: this.state.vehicleModel,
        truckModelId: parseInt(this.state.truckModel),
        truckBrandId: parseInt(this.state.truckBrand),
        uniqueAccessoryId: this.state.accessories,
        vehicleCapacity: parseInt(this.state.seatLimit, 10),
        isActivated: this.state.installStatus,
        status: this.state.status,
        engineNumber: this.state.engineNumber,
        chassisNumber: this.state.chassisNumber,
        accountType: 'PA',
        partnerSubscriptionId: parseInt(this.state.subscriptionId),
        equipmentSerialNumber: this.state.equipmentSerialNumber,
        commissioningDate: commissioningDate,
        idlingSpeed: this.state.idlingSpeed,
        equipmentName: this.state.equipmentName,
        invoiceNumber: this.state.invoiceNumber,
        department: this.state.department,
        contractorName: this.state.contractorName,
        phoneIMEI: this.state.phoneIMEI
      },
      errorPolicy: 'all'
    })

    if (data) {
      this.setState({ response: data.addVehicleDetail })
      this.props.openSnackbar('Registered Successfully')
      this.setState({
        vlpn: '',
        clientName: '',
        serialNumber: '',
        phoneNumber: '',
        speedSensor: '',
        speedLimit: '',
        seatLimit: '',
        vehicleType: '',
        vehicleModel: '',
        showClientDetails: false,
        address: '',
        city: '',
        totalRegisteredVehicle: '',
        totalActiveDevicess: '',
        totalInactiveDevices: '',
        engineNumber: null,
        chassisNumber: null,
        modelName: '',
        deviceType: '',
        simProvider: '',
        simNumber: '',
        subscriptionId: '',
        sparePartName: '',
        idlingSpeed: 3,
        equipmentName: '',
        invoiceNumber: '',
        department: '',
        commissioningDate: {
          date: null,
          unix: moment()
            .unix()
            .toString()
        },
        equipmentSerialNumber: null,
        contractorName: '',
        phoneIMEI: ''
      })
    } else {
      this.setState({ failure: true })
      this.props.openSnackbar(errors[0].message)
    }
  }
  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        status: parseInt(this.state.status, 10)
      },
      fetchPolicy: 'network-only'
    })
    const allClients = clientsDetails.data.clientsDetails.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientsDetails: allClients })
  }
  handleChange = name => event => {
    // console.log('targ', event.target.checked)
    this.setState({ [name]: event.target.checked }, () => {
      console.log(this.state.installStatus, 'kk')
    })
    // console.log('installStatus', event.target.checked, this.state.installStatus)
  }

  getAllBrands = async () => {
    console.log('hihu', this.state.clientName)
    try {
      const brandsDetails = await this.props.client.query({
        query: GET_BRANDS,
        variables: {
          clientLoginId: parseInt(this.state.clientName, 10)
        },
        fetchPolicy: 'network-only'
      })

      const allBrands = brandsDetails.data.getBrands.data.map(brand => ({
        value: brand.id,
        label: brand.name
      }))
      console.log(allBrands)
      this.setState({ brandsDetails: allBrands })
    } catch (error) {
      console.error('Error fetching brands:', error)
      // Optionally handle error (e.g., set an error state)
    }
  }
  getModelsByBrand = async brandId => {
    try {
      console.log(
        'Fetching models for brandId:',
        brandId,
        'and clientLoginId:',
        this.state.clientName
      )

      const modelsDetails = await this.props.client.query({
        query: GET_MODELS_BY_BRAND,
        variables: {
          brandId: parseInt(brandId, 10),
          clientLoginId: parseInt(this.state.clientName, 10)
        },
        fetchPolicy: 'network-only'
      })

      const allModels = modelsDetails.data.getModelsByBrand.data.map(model => ({
        value: model.id,
        label: model.name,
        cumWeight: model.cum_weight,
        clientLoginId: model.client_login_id,
        truckBrandId: model.truck_brand_id,
        createdAt: model.created_at,
        updatedAt: model.updated_at
      }))

      this.setState({ modelsDetails: allModels })

      console.log('Fetched models:', allModels)
    } catch (error) {
      console.error('Error fetching models by brand:', error)
      // Optionally handle error (e.g., set an error state)
      this.setState({ modelsDetails: [] }) // Reset state in case of error
    }
  }

  checkEngineNumber = async () => {
    if (this.state.engineNumber !== '' && this.state.engineNumber !== null) {
      const { data } = await this.props.client.query({
        query: CHECK_ENGINE_NUMBER,
        variables: { engineNumber: this.state.engineNumber }
      })

      this.setState({
        isengineNumberValid:
          data.checkEngineNumber === 'AVAILABLE' &&
          this.state.engineNumber.length > 1 &&
          this.state.engineNumber.length < 41
      })
      // console.log('eng', data.checkEngineNumber)
      if (data.checkEngineNumber !== 'AVAILABLE') {
        this.setState({ engineres: 'Engine Number Already Exist!' })
      } else if (
        (this.state.engineNumber !== '' && this.state.engineNumber !== null) ||
        this.state.engineNumber.length < 1 ||
        this.state.engineNumber.length > 40
      ) {
        this.setState({
          engineres: 'Engine Number should be between 2-40 characters'
        })
      }
    }
    if (this.state.engineNumber === '') {
      this.setState({ engineNumber: null })
    }
  }
  checkChassisNumber = async () => {
    if (this.state.chassisNumber !== '' && this.state.chassisNumber !== null) {
      const { data } = await this.props.client.query({
        query: CHECK_CHASSIS_NUMBER,
        variables: { chassisNumber: this.state.chassisNumber }
      })

      this.setState({
        ischassisNumberValid:
          data.checkChassisNumber === 'AVAILABLE' &&
          this.state.chassisNumber.length > 1 &&
          this.state.chassisNumber.length < 41
      })
      if (data.checkChassisNumber !== 'AVAILABLE') {
        this.setState({ chassisres: 'Chassis Number Already Exist!' })
      } else if (
        (this.state.chassisNumber !== '' &&
          this.state.chassisNumber !== null) ||
        this.state.chassisNumber.length < 1 ||
        this.state.chassisNumber.length > 40
      ) {
        this.setState({
          chassisres: 'Chassis Number should be between 2-40 characters'
        })
      }
    }
    if (this.state.chassisNumber === '') {
      this.setState({ chassisNumber: null })
    }
  }
  componentDidMount() {
    if (this.props.match.params.loginId === undefined) {
      this.getAllClients()
      // this.getAllBrands()
    } else {
      this.getAllClients()
      // this.getAllBrands()
      this.handleChangeClient()
    }
  }

  // vehicleDashboard = e => {
  //   this.props.history.push({
  //     pathname: '/home/VehcileDashboard/Dashboard'
  //   })
  // }

  // bulkRegister = event => {
  //   this.props.history.push({
  //     pathname: '/home/customer/vehicle/register/bulk'
  //   })
  // }

  render() {
    console.log(this.state)
    const { classes } = this.props
    let allSpeedSensor = []
    allSpeedSensor[0] = {
      value: 'GPS SPEED SENSOR',
      label: 'Gps speed sensor'
    }
    allSpeedSensor[1] = {
      value: 'DELTA_DISTANCE_CALCULATION',
      label: 'Delta Distance'
    }
    allSpeedSensor[2] = {
      value: 'ODOMETRIC',
      label: 'Odometric'
    }
    let allIdlingSpeed = [
      {
        value: 0,
        label: 0
      },
      {
        value: 1,
        label: 1
      },
      {
        value: 2,
        label: 2
      },
      {
        value: 3,
        label: 3
      }
    ]

    let vehiclearr = [
      'Car',
      'Truck',
      'Ambulance',
      'School Bus',
      'Bike',
      'Sixseater',
      'Stacker',
      'Tow',
      'Tug',
      'Tractor',
      'Excavator',
      '3-Wheeler',
      'GeneratorTanker',
      'Dumper',
      'Doser',
      'Grader',
      'Loader',
      'Water Sprinkler',
      'Roller',
      'Fuel Tanker',
      'Surface Miner',
      'Service Van',
      'Premium Buggy'
    ]
    const allvehicleTypes = vehiclearr.map(vehicle => ({
      value: vehicle,
      label: vehicle
    }))

    return (
      <div className="Landing">
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            className="btn"
            onClick={() => this.props.history.goBack()}
          >
            Back
          </Button>
          <Grid
            container
            justify="center"
            className="full-screen"
            alignItems="flex-end"
          />
          <Grid item xs={12}>
            {/* <ItemCard className="form_layout"> */}
            <h3 className="Formheader">Register Vehicle</h3>
            <form>
              <div className="formouter">
                <Grid container>
                  <Grid container className="searchdiv" spacing="8">
                    <Grid item xs={12} sm={12} justify="center">
                      <label
                        style={{
                          marginRight: '20px'
                        }}
                      >
                        Customer Name :{' '}
                      </label>

                      <FormControl
                        style={{
                          minWidth: '50%'
                        }}
                      >
                        <FormGroup className="form-input">
                          {/* <InputLabel htmlFor="selectLabel">
                            Select Client
                          </InputLabel> */}

                          <Select
                            classes={classes}
                            options={this.state.clientsDetails}
                            // components={components}
                            value={this.state.clientName}
                            onChange={this.handleChangeClient}
                            placeholder="Select Customer *"
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isClientNameValid
                              ? 'Invalid Selection'
                              : ''}
                          </FormHelperText>
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    {this.state.showClientDetails && (
                      <ClientDetails
                        clientName={this.state.client}
                        address={this.state.address}
                        city={this.state.city}
                      />
                    )}
                  </Grid>
                  <Grid
                    container
                    fullwidth
                    style={{
                      marginTop: '20px'
                    }}
                  >
                    <Grid item xs={12} sm={6}>
                      <Grid xs={12} sm={12}>
                        Vehicle Info:
                      </Grid>
                      <Grid item xs={12} sm={12} fullwidth>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vlpn"
                              name="vlpn"
                              className="textfield"
                              margin="dense"
                              label="Vehicle Number"
                              // type="Multi-line"
                              value={this.state.vlpn}
                              required
                              onChange={this.handleInputChange('vlpn')}
                              error={!this.state.isVlpnValid}
                              onBlur={this.checkVlpnValidity(this.props.client)}
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isVlpnValid
                                ? this.state.vlpnres
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      <Grid item xs={12} sm={12} fullwidth>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="engineNumber"
                              name="engineNumber"
                              className="textfield"
                              margin="dense"
                              label="Engine Number"
                              // type="Multi-line"
                              value={this.state.engineNumber}
                              onChange={this.handleInputChange('engineNumber')}
                              onBlur={this.checkEngineNumber}
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isengineNumberValid
                                ? this.state.engineres
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} fullwidth>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="chassisNumber"
                              name="chassisNumber"
                              className="textfield"
                              margin="dense"
                              label="Chassis Number"
                              // type="Multi-line"
                              value={this.state.chassisNumber}
                              onChange={this.handleInputChange('chassisNumber')}
                              onBlur={this.checkChassisNumber}
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.ischassisNumberValid
                                ? this.state.chassisres
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={allSpeedSensor}
                              // components={components}
                              value={this.state.speedSensor}
                              onChange={this.handleChangeSpeedSensor}
                              placeholder="Select Speed Sensor *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedSensorValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="speedLimit"
                              name="speedLimit"
                              className="textfield"
                              margin="dense"
                              label="Speed Limit"
                              type="text"
                              // type="Multi-line"
                              value={this.state.speedLimit}
                              required
                              onChange={this.handleInputChange('speedLimit')}
                              error={!this.state.isSpeedLimitValid}
                              onBlur={this.checkSpeedLimitValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedLimitValid
                                ? 'Invalid Speed Limit'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Grid xs={12} sm={12}>
                          Idling Speed:
                        </Grid>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={allIdlingSpeed}
                              // components={components}
                              value={this.state.idlingSpeed}
                              onChange={this.handleChangeIdlingSpeed}
                              placeholder="Select Idling Speed "
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="invoiceNumber"
                              name="invoiceNumber"
                              className="textfield"
                              margin="dense"
                              label="Invoice Number"
                              type="text"
                              // type="Multi-line"
                              value={this.state.invoiceNumber}
                              onChange={this.handleInputChange('invoiceNumber')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="equipmentSerialNumber"
                              name="equipmentSerialNumber"
                              className="textfield"
                              margin="dense"
                              label="Equipment Serial Number"
                              type="text"
                              // type="Multi-line"
                              value={this.state.equipmentSerialNumber}
                              onChange={this.handleInputChange(
                                'equipmentSerialNumber'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="equipmentName"
                              name="equipmentName"
                              className="textfield"
                              margin="dense"
                              label="Equipment Name"
                              type="text"
                              // type="Multi-line"
                              value={this.state.equipmentName}
                              onChange={this.handleInputChange('equipmentName')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} fullwidth="true">
                        <FormControl
                          style={{
                            minWidth: '70%'
                          }}
                        >
                          <FormGroup className="form-input">
                            <DatePicker
                              format="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={this.state.commissioningDate.date}
                              onChange={this.handleDateChange(
                                'commissioningDate'
                              )}
                              label="Commissioning Date"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="department"
                              name="department"
                              className="textfield"
                              margin="dense"
                              label="Department"
                              type="text"
                              // type="Multi-line"
                              value={this.state.department}
                              onChange={this.handleInputChange('department')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="contractorName"
                              name="contractorName"
                              className="textfield"
                              margin="dense"
                              label="Contractor Name"
                              type="text"
                              // type="Multi-line"
                              value={this.state.contractorName}
                              onChange={this.handleInputChange(
                                'contractorName'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vinNumber"
                              name="vinNumber"
                              className="textfield"
                              margin="dense"
                              label="VIN Number"
                              // type="Multi-line"
                              value={this.state.vinNumber}
                              
                              onChange={this.handleInputChange('vinNumber')}
                              // error={!this.state.isVinNumber}
                              // onBlur={this.checkVehicleModelValidity}
                            />
                            {/* <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isVehicleModelValid
                                ? 'Invalid Vehicle Model'
                                : ''}
                            </FormHelperText> */}
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Select Vehicle Type
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={allvehicleTypes}
                              // components={components}
                              value={this.state.vehicleType}
                              onChange={this.handleChangeType}
                              placeholder="Select vehicle Type *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      {this.state.vehicleType === 'Truck' ? (
                        <div>
                          <Grid item xs={12} sm={12}>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <Select
                                  classes={classes}
                                  options={this.state.brandsDetails}
                                  value={this.state.truckBrand}
                                  onChange={this.handleChangeBrand}
                                  placeholder="Select Brand Type *"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isClientNameValid
                                    ? 'Invalid Selection'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <Select
                                  classes={classes}
                                  options={this.state.modelsDetails}
                                  value={this.state.truckModel}
                                  onChange={this.handleChangeModel}
                                  placeholder="Select Model Type *"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isClientNameValid
                                    ? 'Invalid Selection'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vehicleModel"
                              name="vehicleModel"
                              className="textfield"
                              margin="dense"
                              label="Vehicle Model"
                              // type="Multi-line"
                              value={this.state.vehicleModel}
                              required
                              onChange={this.handleInputChange('vehicleModel')}
                              error={!this.state.isVehicleModelValid}
                              onBlur={this.checkVehicleModelValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isVehicleModelValid
                                ? 'Invalid Vehicle Model'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.installStatus}
                              onChange={this.handleChange('installStatus')}
                              value="installStatus"
                              color="primary"
                            />
                          }
                          label="Installation Completed"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid xs={12} sm={12}>
                        Device Info:
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup>
                            <Select
                              classes={classes}
                              options={this.state.deviceDetails}
                              //  components={components}
                              value={this.state.serialNumber}
                              onChange={this.handleChangeDevice(
                                this.props.client
                              )}
                              placeholder="Select Device *"
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSerialNumberValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="modelName"
                              name="modelName"
                              className="textfield"
                              margin="dense"
                              label="Model Name"
                              type="text"
                              disabled
                              value={this.state.modelName}
                              required
                              onChange={this.handleInputChange('modelName')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="deviceType"
                              name="deviceType"
                              className="textfield"
                              margin="dense"
                              label="Device Type"
                              type="text"
                              disabled
                              value={this.state.deviceType}
                              required
                              onChange={this.handleInputChange('deviceType')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Select Phoneno
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={this.state.simDetails}
                              // components={components}
                              value={this.state.phoneNumber}
                              onChange={this.handleChangePhoneNumber(
                                this.props.client
                              )}
                              placeholder="Select Phoneno *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isPhoneNoValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="simProvider"
                              name="simProvider"
                              className="textfield"
                              margin="dense"
                              label="Service Provider"
                              type="text"
                              disabled
                              value={this.state.simProvider}
                              required
                              onChange={this.handleInputChange('simProvider')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="simNumber"
                              name="simNumber"
                              className="textfield"
                              margin="dense"
                              label="SIM Number"
                              // type="Multi-line"
                              value={this.state.simNumber}
                              disabled
                              onChange={this.handleInputChange('simNumber')}
                              required
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Accessories
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={this.state.accessoryDetails}
                              // components={components}
                              value={this.state.accessories}
                              onChange={this.handleChangeAccessories}
                              placeholder="Select Accessories"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedSensorValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            {/* <InputLabel htmlFor="selectLabel">
                              Accessories
                            </InputLabel> */}

                            <Select
                              classes={classes}
                              options={this.state.subscriptionDetails}
                              // components={components}
                              value={this.state.subscriptionId}
                              onChange={this.handleChangeSubscription}
                              placeholder="Select Subscription(SoftwareQty-Charges) *"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid style={{ marginTop: '15px' }} item xs={6}>
                        <FormControl className="selectbox">
                          <FormGroup>
                            <FormControlLabel
                              control={<Switch />}
                              onChange={() =>
                                this.setState({
                                  addPhoneDetails: !this.state.addPhoneDetails
                                })
                              }
                              checked={this.state.addPhoneDetails}
                              label={'Mobile Details'}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      {this.state.addPhoneDetails && (
                        <Grid item xs={12} sm={12}>
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="seatLimit"
                                name="seatLimit"
                                className="textfield"
                                margin="dense"
                                label="IMEI  Number"
                                // type="Multi-line"
                                type="number"
                                error={
                                  this.state.addPhoneDetails &&
                                  !this.state.phoneIMEI.length
                                }
                                required={this.state.addPhoneDetails}
                                value={this.state.phoneIMEI}
                                onChange={this.handleInputChange('phoneIMEI')}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      )}
                      {this.state.isseatLimitValid && (
                        <Grid item xs={12} sm={12}>
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="seatLimit"
                                name="seatLimit"
                                className="textfield"
                                margin="dense"
                                label="Seat Capacity"
                                type="text"
                                // type="Multi-line"
                                value={this.state.seatLimit}
                                required
                                onChange={this.handleInputChange('seatLimit')}
                                error={!this.state.isSeatLimitValid}
                                onBlur={this.checkSeatLimitValidity}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {!this.state.isSeatLimitValid
                                  ? 'Invalid Seat Capacity'
                                  : ''}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <FormGroup className="form-input">
                  <Grid justify="center" container>
                    <Button
                      color="default"
                      variant="outlined"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="medium"
                      margin="normal"
                      className="btn"
                      type="button"
                      onClick={this.handleSubmit(this.props.client)}
                      disabled={
                        !(this.state.isVlpnValid &&
                        this.state.vlpn !== '' &&
                        this.state.isSerialNumberValid &&
                        this.state.isPhoneNoValid &&
                        this.state.isClientNameValid &&
                        this.state.isSpeedLimitValid &&
                        this.state.isVehicleModelValid &&
                        this.state.isVehicleTypeValid &&
                        this.state.isSpeedSensorValid &&
                        this.state.uniqueDeviceId !== '' &&
                        this.state.simId !== '' &&
                        this.state.speedSensorType !== '' &&
                        this.state.speedLimit !== '' &&
                        this.state.vehicleType !== '' &&
                        this.state.vehcleModel !== '' &&
                        this.state.showClientDetails &&
                        this.state.address !== '' &&
                        this.state.city !== '' &&
                        this.state.isengineNumberValid &&
                        this.state.ischassisNumberValid &&
                        this.state.subscriptionId !== '' &&
                        this.state.addPhoneDetails
                          ? this.state.phoneIMEI.length
                          : true)
                      }
                    >
                      Submit
                    </Button>
                  </Grid>
                </FormGroup>
              </div>
            </form>
            {/* </ItemCard> */}
          </Grid>
        </Grid>
      </div>
    )
  }
}
VehicleRegistration.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withApollo(withSharedSnackbar(VehicleRegistration))



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/index.jsx